import { emotionTheme } from '@styles/theme'
import { CheckCircleIcon } from '@phosphor-icons/react'

import { ArrowRightCurveCircleIcon } from '@assets/svgs/ArrowRightCurveCircleIcon'

import type { OcNfStatusProps } from './types'

import * as S from './styles'

export const OcNfStatus = ({ status }: OcNfStatusProps) => {
  if (!status) return null

  const statusMap = {
    current: {
      icon: <CheckCircleIcon size={18} />,
      label: 'Vigente',
      color: emotionTheme.colors.green[500],
      background: emotionTheme.colors.green[100]
    },
    transferred: {
      icon: <ArrowRightCurveCircleIcon />,
      label: 'Transferida',
      color: '#199CDA',
      background: 'rgba(25, 157, 218, 0.10)'
    }
  }

  return (
    <S.Container>
      <S.Content
        style={{
          color: statusMap[status].color,
          background: statusMap[status].background
        }}
      >
        {statusMap[status].label}
        {statusMap[status].icon}
      </S.Content>
    </S.Container>
  )
}
